export enum CountrySpecificLabelIssue {
    MISSING = 'Missing',
    INCORRECT = 'Incorrect'
}
